import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import "../../resources/css/common.css";
import "../../resources/css/layout.css";
import ScrollAnimation from "../../resources/js/ScrollAnimation.js";
import Header from "../Header/Header.jsx";
import Footer from "../Footer/Footer.jsx";

const Event = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [news, setNews] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 9;

  useEffect(() => {
    const titleElement = document.getElementsByTagName("title")[0];
    titleElement.innerHTML = `아소비 | 아소비 이벤트`;

    // 페이지 뷰 추적
    window.gtag("config", "G-LYT78YCDYK", {
      page_path: location.pathname,
    });

    // IP 체크 함수
    const checkIP = async () => {
      const response = await fetch("/check-ip");
      const result = await response.json();

      // 리다이렉션 확인
      if (result.redirect) {
        navigate(result.redirect); // navigate로 리다이렉션
      }
    };

    checkIP(); // IP 체크 함수 호출

    const fetchData = async () => {
      const response = await axios.get("/boards"); // 여기 수정

      if (response.data.length > 0) {
        // gubun이 'BB01'인 뉴스만 필터링
        const filteredNews = response.data.filter(
          (item) => item.gubun === "BB02"
        );

        const sortedNews = filteredNews.sort(
          (a, b) => new Date(b.regDate) - new Date(a.regDate) // 최신 등록 순으로 정렬
        );
        setNews(sortedNews); // 필터링된 뉴스로 설정
      } else {
        setNews([]); // 뉴스가 없을 경우
      }
    };

    fetchData();
  }, [location, navigate]); // navigate 추가

  // 페이지네이션 계산
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = news.slice(indexOfFirstItem, indexOfLastItem);

  // 페이지 수 계산
  const totalPages = Math.ceil(news.length / itemsPerPage);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  // 조회수 증가 함수
  const incrementHit = async (idx) => {
    try {
      await axios.post(`/hitUpdate/${idx}`); // 조회수 증가 API 호출
    } catch (error) {
      console.error("조회수 증가 실패:", error);
    }
  };

  return (
    <div>
      <Header>
        <div className="header-down">
          <div className="wrap">
            <ul>
              <li>
                <a href="/news">아소비 뉴스</a>
              </li>
              <li>
                <a href="/event" className="sel">
                  아소비 이벤트
                </a>
              </li>
              <li>
                <a href="/social">아소비 소셜미디어</a>
              </li>
              {/* <li><a href="../ajax/getBoardList.jsp?r_page=newsletter&page_no=1">아소비 꿀지</a></li> */}
            </ul>
          </div>
        </div>
      </Header>
      <ScrollAnimation />
      <section id="container">
        <div class="subvisual">
          <div class="title">아소비 소식</div>
          <div class="text">
            아소비에서 전하는 소식으로 <br />
            다양한 혜택과 유익한 정보를 공유해보세요!
          </div>
          <div class="image">
            <img src="../custom-resources/img/sub_news_bg.png" alt="" />
          </div>
        </div>
        <div class="breadcrumb">
          <div class="wrap">
            <div class="loca">
              <span>
                <img src="../custom-resources/img/icon_home.png" alt="" />
              </span>
              <span class="on">아소비 소식</span>
            </div>
            <div class="menu">
              <a href="/news">아소비 뉴스</a>
              <a href="/event" class="on">
                아소비 이벤트
              </a>
              <a href="/social">아소비 소셜미디어</a>
              {/* <a href="../ajax/getBoardList.jsp?r_page=newsletter&page_no=1">아소비 꿀지</a> */}
            </div>
          </div>
        </div>
        <div class="event">
          <div class="wrap">
            <div class="title">
              <div class="tit">아소비 이벤트</div>
              <div class="txt">
                다양한 아소비 이벤트 참여하고 혜택도 받으세요!{" "}
              </div>
            </div>
            <div class="cont">
              <div class="list">
                <ul>
				{currentItems.map((item) => (
				  <li key={item.idx}>
				    {item.url1 ? (
				      // 외부 링크
				      <a
				        href={item.url1}
				        target="_blank"
				        rel="noreferrer"
				        className="box"
				        onClick={() => incrementHit(item.idx)} // 클릭 시 조회수 증가 함수 호출
				      >
				        <div className="img">
				          <i></i>
				          <img src={`/static/DATA/board/${item.file1}`} alt="" />
				        </div>
				        <div className="con">
				          <div
				            className={`cate ${
				              new Date(item.bdEnd) < new Date() ? "end" : ""
				            }`}
				          >
				            {new Date(item.bdEnd) >= new Date() ? "진행 중" : "종료"}
				          </div>
				          <div className="subj">{item.title}</div>
				          <div className="text">{item.titleSub}</div>
				          <div className="date">
				            {item.bdStart} ~ {item.bdEnd}
				          </div>
				        </div>
				      </a>
				    ) : (
				      // 내부 링크
				      <Link
				        to={`/event_detail/${item.idx}`}
				        className="box"
				        onClick={() => incrementHit(item.idx)} // 클릭 시 조회수 증가 함수 호출
				      >
				        <div className="img">
				          <i></i>
				          <img src={`../../DATA/board/${item.file1}`} alt="" />
				        </div>
				        <div className="con">
				          <div
				            className={`cate ${
				              new Date(item.bdEnd) < new Date() ? "end" : ""
				            }`}
				          >
				            {new Date(item.bdEnd) >= new Date() ? "진행 중" : "종료"}
				          </div>
				          <div className="subj">{item.title}</div>
				          <div className="text">{item.titleSub}</div>
				          <div className="date">
				            {item.bdStart} ~ {item.bdEnd}
				          </div>
				        </div>
				      </Link>
				    )}
				  </li>
				))}
                </ul>
              </div>
              <div className="paging">
                <a className="start" onClick={() => handlePageChange(1)}>
                  <i></i>
                </a>
                <a
                  className="prev"
                  onClick={() => handlePageChange(currentPage - 1)}
                >
                  <i></i>
                </a>
                {Array.from({ length: totalPages }, (_, index) => (
                  <a
                    key={index + 1}
                    className={currentPage === index + 1 ? "current" : ""}
                    onClick={() => handlePageChange(index + 1)}
                  >
                    {index + 1}
                  </a>
                ))}
                <a
                  className="next"
                  onClick={() => handlePageChange(currentPage + 1)}
                >
                  <i></i>
                </a>
                <a className="end" onClick={() => handlePageChange(totalPages)}>
                  <i></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default Event;
